module.exports = __webpack_public_path__ + "media/images/icons/menu-1af65af1c4478714c730f3645a8bb0a7.svg";